import Config from './Config'
import Detail from './Detail'

export default { Config, Detail }